import { checkDevice } from "v-js-utils";
import lazyloader from "@pernod-ricard-global-cms/cbllazyloader";
import jsAssets from "Assets/js/modules/jsAssets";
import checkBrowserInfo from "Assets/js/modules/check-browser-info";
import siteHeader from "Assets/js/components/site-header";
checkDevice();
checkBrowserInfo();
globalThis.requestAnimationFrame(() => {
    const header = document.querySelector(".site-header");
    siteHeader({ block: header });
});
lazyloader.options.assetArray = jsAssets.dynamicAssets;
lazyloader.options.rootMargin = "100% 0px 100px 0px";
lazyloader.options.filePath = "js/blocks/";
lazyloader.options.debugLogMessages = false;
lazyloader.lazyloaderInit();
